import { ChakraSelect } from 'app/components/Core/ChakraSelect';
import React from 'react';
import { Control, Controller, Path } from 'react-hook-form';
import { ChakraSelectProps } from 'app/components/Core/ChakraSelect/types';
import { Option } from 'types/general.types';

interface ChakraSelectFieldProps<Form extends {}> {
  name: Path<Form>;
  control: Control<Form>;
}

export const ChakraSelectField = <Form extends {}>({
  control,
  name,
  options,
  onChange: onChangeProp,
  ...rest
}: ChakraSelectFieldProps<Form> & ChakraSelectProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, value, onChange, ...fieldProps },
        fieldState: { error },
      }) => (
        <ChakraSelect
          value={value as Option}
          error={Boolean(error?.message)}
          helperText={error?.message}
          options={options}
          mainRef={ref}
          onChange={(e) => {
            if (onChangeProp) {
              onChangeProp(e);
            }
            onChange(e);
          }}
          {...rest}
          {...fieldProps}
        />
      )}
    />
  );
};
